import Modal from './ant';

export default Modal;
